import { generateTableSlice } from "./sliceTable";

const sliceCaregiverActivityTable = generateTableSlice("caregiverActivity");

export const ActionsCaregiverActivityTable =
  sliceCaregiverActivityTable.actions;
export const ReducerCaregiverActivityTable =
  sliceCaregiverActivityTable.reducer;
